import { useEffect } from "react";

// Re-fetch fresh server data whenever the tab/page regains focus or becomes
// visible again, so changes made on another device show up on return.
export function useRefetchOnFocus(callback) {
  useEffect(() => {
    const onFocus = () => { if (document.visibilityState === "visible") callback(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, [callback]);
}
